<template>
  <div class="main-container">
    <!--    顶部标题栏-->
    <Header :status="status" :select="select"></Header>
    <AppMain></AppMain>
    <!--    底部footer栏-->
    <Footer></Footer>
  </div>
</template>

<script>
import AppMain from './components/AppMain'
import Footer from './components/Footer'
import Header from './components/Header'
export default {
  name: 'Layout',
  components: { AppMain, Footer, Header },
  data() {
    return {
    }
  },
  computed: {
    status: function() {
      if (this.$store.getters.usessionid && this.$store.getters.usessionid !== 'undefined') {
        return 2
      } else {
        return 1
      }
    },
    select: function() {
      const path = this.$route.path
      console.log('path', path)
      if (path === '/hasbuy') {
        return 'hasbuy'
      }
      if (path === '/hasread') {
        return 'hasread'
      }
      if (path === '/buy') {
        return 'buy'
      }
      return 'bookshelf'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import '@/common/styles/variables.scss';
body{
  min-width: $min-width;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/PCLayout.vue